import { I } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessagesTasksInbox } from 'src/app/models/IMessagesTasksInbox';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { TaskmessagesnewtaskComponent } from '../taskmessagesnewtask/taskmessagesnewtask.component';
import { TaskmessagesviewComponent } from '../taskmessagesview/taskmessagesview.component';

@Component({
  selector: 'app-tasksandmessages-tab',
  templateUrl: './tasksandmessages-tab.component.html',
  styleUrls: ['./tasksandmessages-tab.component.css']
})
export class TasksandmessagesTabComponent implements OnInit {

  InboxMessagesForm: FormGroup;
  isOpen1: boolean;
  showTableInbox: boolean = true;
  isInboxBtncolor: boolean = false;
  isSentBtncolor: boolean = true;
  isTaskMessagePopUp: boolean = false;
  @Input() taskScrl: boolean = false;
  @Input() screenName: string;
  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus1" || event.currentTarget.activeElement.parentElement.id == "selectLoc") {
      this.isOpen1 = true
    }
    else {
      event.stopPropagation();
      this.isOpen1 = false
    }
  }
  constructor(public dialog: MatDialog, private spinner: NgxSpinnerService, private fb: FormBuilder,
    private tasksMessageservice: TasksAndGroupsService, private schedulerservice: SchedularServiceService, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>
    , private dateservice: SharedService) { }
  InboxMessagesDatasource = new MatTableDataSource<IMessagesTasksInbox>();
  SentMessagesDatasource = new MatTableDataSource<IMessagesTasksInbox>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  columnsToDisplay = ['UserName', 'MessagesType', 'Subject', 'PatientName', 'CreatedDate', 'StatusName', 'AcceptedByName', 'LocationName', 'DueDate']
  filterValues = { UserName: '', MessagesType: '', Subject: '', PatientName: '', CreatedOn: '', StatusName: '', AcceptedByName: '', LocationName: '', DueDate: '' };
  userNameFilter = new FormControl('');
  MessagesTypeFilter = new FormControl('');
  SubjectFilter = new FormControl('');
  PatientNameFilter = new FormControl('');
  CreatedOnFilter = new FormControl('');
  StatusNameFilter = new FormControl('');
  AcceptedByNameFilter = new FormControl('');
  LocationNameFilter = new FormControl('');
  dueDateFilter = new FormControl('');
  ngOnInit() {
    $('.boxback3').removeClass('boxback3');
    this.InboxMessagesForm = this.fb.group({
      IsLocationCheck: [true],
      locations: [''],
      fromdate: [''],
      todate: [''],
      lastDropdown: [''],
      IncludeDuedate: [false]
    });

    this.getLocations()
    this.userNameFilter.valueChanges
      .subscribe(
        userFilter => {
          this.filterValues.UserName = userFilter;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.MessagesTypeFilter.valueChanges
      .subscribe(
        typeFilter => {
          this.filterValues.MessagesType = typeFilter;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.SubjectFilter.valueChanges
      .subscribe(
        subjectFilter => {
          this.filterValues.Subject = subjectFilter;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.PatientNameFilter.valueChanges
      .subscribe(
        patientFilter => {
          this.filterValues.PatientName = patientFilter;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.CreatedOnFilter.valueChanges
      .subscribe(
        createdFilter => {
          this.filterValues.CreatedOn = createdFilter;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.StatusNameFilter.valueChanges
      .subscribe(
        StatusName => {
          this.filterValues.StatusName = StatusName;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.AcceptedByNameFilter.valueChanges
      .subscribe(
        AcceptedByName => {
          this.filterValues.AcceptedByName = AcceptedByName;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.LocationNameFilter.valueChanges
      .subscribe(
        LocationName => {
          this.filterValues.LocationName = LocationName;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.dueDateFilter.valueChanges
      .subscribe(
        MailDueDate => {
          this.filterValues.DueDate = MailDueDate;
          this.InboxMessagesDatasource.filter = JSON.stringify(this.filterValues);
        }
      )

    //this.getAllInBoxItems('', '', '', '');
    // this.checkAllLocations(null)

    //this.isTaskMessagePopUp = this.data == "TaskSideNav" ? true : false;
  }
  locationDate: any = '';
  getLocationDate(fromdateFilter: string, todateFilter: string) {
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.locationDate = result;
      if (this.locationSelected && this.locationSelected != undefined) {
        this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      } else {
        this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      }
    });
  }
  getSystem() {

    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }

  }

  allMessagesInbox: IMessagesTasksInbox[];
  allMessagesSent: IMessagesTasksInbox[];
  public lstLocations1: ILocationDetails[];
  async getLocations() {
    await this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations1 = data;
      this.locationSelected = '';
      if (this.lstLocations1 && this.lstLocations1 != undefined) {
        this.selectedList = [];
        this.selected = '';
        this.selectedName = '';
        this.lstLocations1 = this.lstLocations1.filter(x => x.selected = true)
        this.selectedList = this.lstLocations1;

        for (let index = 0; index < this.lstLocations1.length; index++) {
          this.selectedName += this.lstLocations1[index].locationName + ', ';
          this.locationSelected += this.lstLocations1[index].locationId + ',';
        }
        if (this.selectedList.length != 0) {
          this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
        }
        this.InboxMessagesForm.patchValue({
          locations: this.selectedName
        });
      }
      this.getLocationDate('', '')
    },
      (err: any) => {
        console.log(err);
        this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, '', '');
      });

  }
  checkInboxSend: string = "Inbox";
  clickOn_InboxSend(type: string) {

    this.checkInboxSend = type;
    if (type == "Inbox") {
      this.isInboxBtncolor = false;
      this.isSentBtncolor = true;
      this.showTableInbox = true;

    } else {
      this.isSentBtncolor = false;
      this.isInboxBtncolor = true;
      this.showTableInbox = false;
      //this.getAllSentItems('', this.InboxMessagesForm.value.lastDropdown, '', '');    
    }
    this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, '', '');
  }
  warningMessage: boolean = false;
  warningMessageSent: boolean = false;
  checkLocationDate: string;
  getAllInBoxItems(locations: string, dateMonthYear: string, fromDate: string, toDate: string) {
    this.spinner.show();
    var IsCheckedDueDate = this.InboxMessagesForm.value.IncludeDuedate;
    if (IsCheckedDueDate == true) {
      this.locationDate = this.transform(this.locationDate);
      IsCheckedDueDate = 1;
    } else {
      this.locationDate = "";
      IsCheckedDueDate = 0;
    }
    this.tasksMessageservice.GetAllTaskMessagesInbox(this.checkInboxSend, locations, dateMonthYear, fromDate, toDate, this.locationDate, IsCheckedDueDate).subscribe(data => {

      this.allMessagesInbox = data
      this.InboxMessagesDatasource.data = this.allMessagesInbox;
      if (this.allMessagesInbox.length != 0) {
        this.warningMessage = false;
        this.InboxMessagesDatasource.data.forEach(x => {
          if (x.Status == 1) {
            x.StatusName = 'Open'
          } else if (x.Status == 2) {
            x.StatusName = 'In Progress'
          } else if (x.Status == 3) {
            x.StatusName = 'Completed'
          } else if (x.Status == 4) {
            x.StatusName = 'General';
          } else {
            x.StatusName = '';
          }
        })
      } else {
        this.warningMessage = true;
      }
      this.InboxMessagesDatasource.filterPredicate = this.createFilter();
      this.InboxMessagesDatasource.paginator = this.paginator;

      this.spinner.hide();
    },
      (err: any) => {
        console.log(err)
        this.spinner.hide();
      });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.UserName === null || "" ? "" : data.UserName).toString().toLowerCase().indexOf(searchTerms.UserName.toLowerCase()) !== -1
        && (data.MessagesType === null || "" ? "" : data.MessagesType).toString().toLowerCase().indexOf(searchTerms.MessagesType.toLowerCase()) !== -1
        && (data.Subject === null || "" ? "" : data.Subject).toString().toLowerCase().indexOf(searchTerms.Subject.toLowerCase()) !== -1
        && (data.PatientName === null || "" ? "" : data.PatientName).toString().toLowerCase().indexOf(searchTerms.PatientName.toLowerCase()) !== -1
        && (data.CreatedDate === null || "" ? "" : data.CreatedDate).toString().toLowerCase().indexOf(searchTerms.CreatedOn.toLowerCase()) !== -1
        && (data.Status === null || "" ? "" : data.Status).toString().toLowerCase().indexOf(searchTerms.StatusName.toLowerCase()) !== -1
        && (data.AcceptedByName === null || "" ? "" : data.AcceptedByName).toString().toLowerCase().indexOf(searchTerms.AcceptedByName.toLowerCase()) !== -1
        && (data.LocationName === null || "" ? "" : data.LocationName).toString().toLowerCase().indexOf(searchTerms.LocationName.toLowerCase()) !== -1
        && (data.MailDueDate === null || "" ? "" : data.MailDueDate).toString().indexOf(searchTerms.DueDate.toLowerCase()) !== -1
        ;
    }
    return filterFunction;
  }
  funCreateNewTask() {
    // if (this.isTaskMessagePopUp) {
    //   this.dialogRef.close();
    // }
    const dialogRef = this.dialog.open(TaskmessagesnewtaskComponent, { width: '70% ', height: '600px', data: this.isQuickBtn }
    );
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
        this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, '', this.checkInboxSend);
      }
      this.clearfiltervalues();
      this.InboxMessagesForm.patchValue({
        lastDropdown: '',
        fromdate: '',
        todate: ''
      });
    });
  }

  @Output() taskmessagesideNav = new EventEmitter<any>();
  funViewNewTask(MessageTaskMasterId, row: IMessagesTasksInbox) {
    // if (this.isTaskMessagePopUp) {
    //   this.dialogRef.close();
    // }
    sessionStorage.setItem("patientDob",row.patientDob);
    if (this.checkInboxSend == 'Inbox' && !row.IsReaded) {
      this.UpdateIsReadableTaskAndMessages(MessageTaskMasterId, row.IsUserMappingId, row.ReplyandForwardStatus);

    }
    
    const dialogRef = this.dialog.open(TaskmessagesviewComponent, {
      width: '90%', height: '90%',
      data: { Id: MessageTaskMasterId, ele: row, btnType: this.checkInboxSend, IsSideNav: false }
    });
    dialogRef.afterClosed().subscribe(result => {

      //this.taskmessagesideNav.emit("close");
      // if(result != undefined)
      this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), '', '', '');
      this.InboxMessagesForm.patchValue({
        lastDropdown: '',
        fromdate: '',
        todate: ''
      });

     
      //this.clearSearchValues();
    });
  }
  clearfiltervalues() {
    this.StatusNameFilter.setValue("");
    this.userNameFilter.setValue("");
    this.MessagesTypeFilter.setValue("");
    this.SubjectFilter.setValue("");
    this.PatientNameFilter.setValue("");
    this.CreatedOnFilter.setValue("");
    this.LocationNameFilter.setValue("");
    this.AcceptedByNameFilter.setValue("");
    this.dueDateFilter.setValue("")
  }
  clearSearchValues() {
    this.InboxMessagesForm.patchValue({
      lastDropdown: '',
      fromdate: '',
      todate: ''
    })
    this.getLocations();
  }

  clearTaskMessageSearchValue() {
    //this.isTaskMessagePopUp = false;
    this.checkInboxSend = "Inbox";
    this.isInboxBtncolor = false;
    this.isSentBtncolor = true;
    this.showTableInbox = true;
    if (this.InboxMessagesForm != null) {
      if (this.InboxMessagesForm.value) {
        this.InboxMessagesForm.patchValue({
          lastDropdown: '',
          fromdate: '',
          todate: ''
        })
      }
    }
    if (this.allMessagesInbox != undefined) {
      if (this.allMessagesInbox.length > 0) {
        this.allMessagesInbox = [];
        this.InboxMessagesDatasource.data = [];
      }
    }

    this.clearfiltervalues();
  }
  isQuickBtn: boolean = false;
  fnSetLocationFromParent() {

    this.clearTaskMessageSearchValue();
    this.getLocations();
    this.getSystem();
    this.isQuickBtn = true;
  }
  //********* Newly Added Multiselect dropdown */
  LocationFocus() {
    this.isOpen1 = true;
  }
  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {

      $('#locationsfocushide').hide()
      // setTimeout(() => {
      //   this.userRoleId.nativeElement.focus();
      // }, 100);

      this.isOpen1 = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus1") {
      $('#locationlistoption0').focus();
    }
  }

  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  arryOfselectedLocationsIdsUpdate: string[] = [];
  selectedList: ILocationDetails[] = [];
  selected = '';
  selectedName = '';
  locationSelected = ''
  checkAllLocations(event) {

    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    var fromdateFilter = ""
    var todateFilter = "";

    if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
      this.transform(this.InboxMessagesForm.value.fromdate) == "") {
      fromdateFilter = "";
    } else {
      fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
    }
    if (this.transform(this.InboxMessagesForm.value.todate) == null ||
      this.transform(this.InboxMessagesForm.value.todate) == "") {
      todateFilter = "";
    } else {
      todateFilter = this.transform(this.InboxMessagesForm.value.todate);
    }
    if (ischk == true) {
      this.selectedList = [];
      this.selected = '';
      this.selectedName = '';
      this.lstLocations1 = this.lstLocations1.filter(x => x.selected = true)
      this.selectedList = this.lstLocations1;

      for (let index = 0; index < this.lstLocations1.length; index++) {
        this.selectedList[index].selected = true;
        this.locationSelected += this.selectedList[index].locationId + ',';
        this.selectedName += this.selectedList[index].locationName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
      }
      this.InboxMessagesForm.patchValue({
        locations: this.selectedName
      });
      // this.getAllInBoxItems(this.locationSelected, '', '', '');


      if (this.locationSelected && this.locationSelected != undefined) {
        this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      } else {
        this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      }
    } else {
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
        this.locationSelected = '';
      }

      this.selected = '';
      this.selectedName = '';
      this.InboxMessagesForm.patchValue({
        locations: this.selectedName
      });
      this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);

    }
  }
  LocationSelectionChanged(LocationupdateRef) {

    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value);
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = []
    this.arryOfselectedLocationsIdsUpdate = [];
    this.locationSelected = '';
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.locationSelected += this.locationsList[index].locationId + ',';
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    this.lstLocations1.filter(x => x.selected = false) // default set false
    this.lstLocations1.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)
    this.InboxMessagesForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2)
    })
    this.checkAllLocationsSelect_Deselect();

    var fromdateFilter = ""
    var todateFilter = "";

    if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
      this.transform(this.InboxMessagesForm.value.fromdate) == "") {
      fromdateFilter = "";
    } else {
      fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
    }
    if (this.transform(this.InboxMessagesForm.value.todate) == null ||
      this.transform(this.InboxMessagesForm.value.todate) == "") {
      todateFilter = "";
    } else {
      todateFilter = this.transform(this.InboxMessagesForm.value.todate);
    }


    if (this.locationSelected && this.locationSelected != undefined) {
      this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
    } else {
      this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
    }
  }
  checkAllLocationsSelect_Deselect() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations1.length) {
        this.InboxMessagesForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.InboxMessagesForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.InboxMessagesForm.patchValue({
        IsLocationCheck: false
      });
    }
  }
  onChangeLast(event) {

    var firstDay = new Date();
    var nextdate = firstDay;
    if (event.target.value == 'week') {
      nextdate = new Date(firstDay.getTime() - 7 * 24 * 60 * 60 * 1000);
    } else if (event.target.value == 'month') {
      nextdate = new Date(nextdate.setMonth(nextdate.getMonth() - 1));
    } else if (event.target.value == 'year') {
      nextdate = new Date((nextdate.setDate(nextdate.getDate() - 365)));
    }
    if (event.target.value != '') {
      this.InboxMessagesForm.patchValue({
        todate: new Date(),
        fromdate: nextdate
      })
      var selectedValue = event.target.value;
      var fromdateFilter = ""
      var todateFilter = "";

      if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
        this.transform(this.InboxMessagesForm.value.fromdate) == "") {
        fromdateFilter = "";
      } else {
        fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
      }
      if (this.transform(this.InboxMessagesForm.value.todate) == null ||
        this.transform(this.InboxMessagesForm.value.todate) == "") {
        todateFilter = "";
      } else {
        todateFilter = this.transform(this.InboxMessagesForm.value.todate);
      }
      if (this.locationSelected && this.locationSelected != undefined) {
        this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      } else {
        this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      }

    } else {
      this.InboxMessagesForm.patchValue({
        fromdate: '',
        todate: ''
      })
      this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), fromdateFilter, todateFilter, this.checkInboxSend);
    }
  }
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  onKeyPressAppointmentdate(event) {
    //var evntValue=event.target.value;  
    this.InboxMessagesForm.patchValue({
      lastDropdown: ''
    })
    if (new Date(this.InboxMessagesForm.value.fromdate) > new Date(this.InboxMessagesForm.value.todate)) {
      this.toastr.error("To date should be greater than From date");
      return false;
    }

    if (this.InboxMessagesForm.value.fromdate === null) {
      this.toastr.error("Please Select From Date.");
      // return false;
    } else if (this.InboxMessagesForm.value.todate === null) {
      this.toastr.error("Please Select To Date.");
      //return false;
    }
    var appointmentDateFilter = ""
    var fromdateFilter = ""
    var todateFilter = "";
    if (this.transform(this.InboxMessagesForm.value.appointmentDate) == null ||
      this.transform(this.InboxMessagesForm.value.appointmentDate) == "") {
      appointmentDateFilter = "";
    } else {
      appointmentDateFilter = this.transform(this.InboxMessagesForm.value.appointmentDate);
    }
    if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
      this.transform(this.InboxMessagesForm.value.fromdate) == "") {
      fromdateFilter = "";
    } else {
      fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
    }
    if (this.transform(this.InboxMessagesForm.value.todate) == null ||
      this.transform(this.InboxMessagesForm.value.todate) == "") {
      todateFilter = "";
    } else {
      todateFilter = this.transform(this.InboxMessagesForm.value.todate);
    }
    if (this.locationSelected && this.locationSelected != undefined) {
      this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
    }

  }
  onDORDateChanged() {
    this.InboxMessagesForm.patchValue({
      lastDropdown: ''
    })
    var fromdateFilter = ""
    var todateFilter = "";

    if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
      this.transform(this.InboxMessagesForm.value.fromdate) == "") {
      fromdateFilter = "";
    } else {
      fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
    }
    if (this.transform(this.InboxMessagesForm.value.todate) == null ||
      this.transform(this.InboxMessagesForm.value.todate) == "") {
      todateFilter = "";
    } else {
      todateFilter = this.transform(this.InboxMessagesForm.value.todate);
    }

    if (new Date(this.InboxMessagesForm.value.fromdate) > new Date(this.InboxMessagesForm.value.todate)) {
      this.toastr.error("To date should be greater than From date");
      return false;
    }

    if (this.InboxMessagesForm.value.fromdate === null) {
      this.toastr.error("Please Select From Date.");
      //  return false;
    } else if (this.InboxMessagesForm.value.todate === null) {
      this.toastr.error("Please Select To Date.");
      // return false;
    }
    // if (this.InboxMessagesForm.value.locations == "" && this.InboxMessagesForm.value.locations != null && this.InboxMessagesForm.value.locations != undefined) {
    //   this.InboxMessagesForm.controls['locations'].setValue(0);
    // }


    if (this.locationSelected && this.locationSelected != undefined) {
      this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
    } else {
      this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);

    }
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  btnStatusColor(status: number) {
    switch (status) {
      case 1: return "#a96adf"; break;
      case 2: return "#f19e0d"; break;
      case 3: return "#33ad38"; break;
      default:
        return "#1e88e5";
    }
  }

  checkIsDuedate(event) {

    var fromdateFilter = ""
    var todateFilter = "";

    if (this.transform(this.InboxMessagesForm.value.fromdate) == null ||
      this.transform(this.InboxMessagesForm.value.fromdate) == "") {
      fromdateFilter = "";
    } else {
      fromdateFilter = this.transform(this.InboxMessagesForm.value.fromdate);
    }
    if (this.transform(this.InboxMessagesForm.value.todate) == null ||
      this.transform(this.InboxMessagesForm.value.todate) == "") {
      todateFilter = "";
    } else {
      todateFilter = this.transform(this.InboxMessagesForm.value.todate);
    }
    if (event.target.checked) {
      this.getLocationDate(fromdateFilter, todateFilter);
      this.InboxMessagesForm.patchValue({
        IncludeDuedate: true
      });
    } else {
      this.InboxMessagesForm.patchValue({
        IncludeDuedate: false
      });
      if (this.locationSelected && this.locationSelected != undefined) {
        this.getAllInBoxItems(this.locationSelected.substring(0, this.locationSelected.length - 1), this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      } else {
        this.getAllInBoxItems('', this.InboxMessagesForm.value.lastDropdown, fromdateFilter, todateFilter);
      }
    }
  }
  IsReadableInfo: IMessagesTasksInbox
  UpdateIsReadableTaskAndMessages(TaskId: number, UsermapId: number, mailStatus: number) {
    this.IsReadableInfo = {} as IMessagesTasksInbox;
    this.IsReadableInfo.IsUserMappingId = UsermapId;
    this.IsReadableInfo.OldTaskId = TaskId;
    this.IsReadableInfo.FromUserId = encodeURIComponent(sessionStorage.getItem("userId"));
    this.IsReadableInfo.ReplyandForwardStatus = mailStatus
    this.tasksMessageservice.UpdateIsReadedTasksInfo(this.IsReadableInfo).subscribe((results: any) => {
      //this.toastr.success(results);
    });

  }
}
